'use client';
import { create } from 'zustand';
import { Profile } from '../types/profile';
import { ActionFeedbackProps } from '../../ui/shared/module-actions-feedback';
import { createJSONStorage, persist } from 'zustand/middleware';

export enum ProfileLoading {
  UPDATE = 'update',
  DELETE = 'delete',
}
type ProfileState = {
  actionFeedback: ActionFeedbackProps | null;
  error: Error | null;
  isLoading: ProfileLoading | null;
  profile: Profile | null;
  setActionFeedback: (feedback: ActionFeedbackProps | null) => void;
  setProfile: (user: Profile | null) => void;
  setIsLoading: (status: ProfileLoading | null) => void;
  setError: (error: Error | null) => void;
  resetStore: () => void;
  resetLoadingState: () => void;
};

const initialState: Omit<
  ProfileState,
  | 'setActionFeedback'
  | 'setProfile'
  | 'setIsLoading'
  | 'setError'
  | 'resetStore'
  | 'resetLoadingState'
> = {
  profile: null,
  isLoading: null,
  error: null,
  actionFeedback: null,
};

export const useProfileStore = create(
  persist<ProfileState>(
    (set) => ({
      ...initialState,
      setProfile: (profile) => set({ profile }),
      setIsLoading: (isLoading: ProfileLoading | null) => set({ isLoading }),
      setError: (error: Error | null) => set({ error }),
      setActionFeedback: (actionFeedback) => set({ actionFeedback }),
      resetStore: () => set(initialState),
      resetLoadingState: () => set((state) => ({ ...state, error: null, isLoading: null })),
    }),
    {
      name: 'profile-storage', // Nome del salvataggio persistente
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
